import { Skull } from "lucide-react"

import { Badge } from "@/components/ui/badge"
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip"

/**
 * Player availability badge shared across match lineup, team roster, and
 * player-detail surfaces. Renders the Miss-Next-Game (with injury tooltip) and
 * Dead cases; the positive "Healthy" badge is opt-in since only the player page
 * shows it. Keep this minimal — no size/variant knobs until a fourth consumer
 * demands them.
 */
export function PlayerStatusBadge({
  status,
  injuryDescription,
  showHealthy = false,
}: {
  status: string
  injuryDescription?: string | null
  showHealthy?: boolean
}) {
  if (status === "miss_next") {
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <span>
            <Badge variant="warning" className="text-xs">
              MNG
            </Badge>
          </span>
        </TooltipTrigger>
        <TooltipContent>
          <p>
            Miss Next Game
            {injuryDescription ? ` — ${injuryDescription}` : ""}
          </p>
        </TooltipContent>
      </Tooltip>
    )
  }

  if (status === "dead") {
    return (
      <Badge variant="destructive" className="text-xs">
        <Skull className="mr-0.5 size-3" />
        Dead
      </Badge>
    )
  }

  if (showHealthy && status === "active") {
    return <Badge variant="success">Healthy</Badge>
  }

  return null
}
